import { Box, IconButton, keyframes, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import ContatosDialog from '../dialogs/ContatosDialog';
import { t } from 'i18next';

const pulse = keyframes`
  0% {
    transform: scale(1);
    filter: drop-shadow(0 0 0px rgba(27, 32, 29, 0));
  }
  70% {
    transform: scale(1.1);
    filter: drop-shadow(0 0 6px rgba(37, 211, 102, 0.5));
  }
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0px rgba(37, 211, 102, 0));
  }
`;

export default function WhatsappFloatingButton() {

    const [open, setOpen] = useState(false);
    
    const theme = useTheme();

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);
    
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    
    if (!mounted) return null;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Tooltip title={t('ContatosDialog.contatosDialogTitle')}>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    right: isMobile ? 8 : 16,
                    zIndex: 1500,
                    cursor: 'pointer',
                    animation: `${pulse} 2s infinite`,
                }}
            >
                <IconButton onClick={handleClickOpen} disableRipple>
                    <img
                        src="/assets/WhatsApp.svg.webp"
                        alt="WhatsApp"
                        width={isDesktop ? 86 : 54}
                        height={isDesktop ? 86 : 54}
                    />
                </IconButton>
                <ContatosDialog
                    open={open}
                    onClose={handleClose}
                />
            </Box>
        </Tooltip>
    );
}